import React from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {GatsbyImage} from 'gatsby-plugin-image';

import Button from './button';
import Container from './container';
import Flex from './flex';
import Link from './link';
import Logo from './logo';
import LogoIcon from './logoIcon';
import Text from './text';

import {
  rightArrowSvg,
  footerWrapper,
  linkWrapper,
  linkGrid,
  linkDivider,
  callToAction,
  avainlippu,
  logoIconWrapper,
  logoIcon,
} from './footer.module.css';

const RightArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 128 69.79"
    preserveAspectRatio="none"
    className={rightArrowSvg}
  >
    <path
      d="M126.12,33.29,123.85,31l-1.33-1.34L93.72,0h-11l30.11,31H0v7.75H113.43L83,69.79H94l28.57-29.14,1.88-1.88,1.72-1.72L128,35.17Z"
      fill="#2a2765"
      fillRule="evenodd"
    />
  </svg>
);

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      suomalaistaPalvelua: file(relativePath: {eq: "suomalaistapalvelua.png"}) {
        childImageSharp {
          gatsbyImageData(width: 130)
        }
      }
    }
  `);

  return (
    <div as="footer" className={footerWrapper}>
      <Container>
        <Flex flexWrap="wrap">
          <div className={linkWrapper}>
            <div className={linkGrid}>
              <Link to="/mika-on-urakkadiili">
                <RightArrow />
                Mikä on UrakkaDiili?
              </Link>
              <Link to="/urakoitsijalle">
                <RightArrow />
                Urakoitsijalle
              </Link>
              <Link to="/kotitalousvahennys">
                <RightArrow />
                Kotitalousvähennys 2025
              </Link>
              <Link to="/kotitalousvahennyslaskuri">
                <RightArrow />
                Kotitalousvähennyslaskuri
              </Link>
              <Link to="/kokemuksia">
                <RightArrow />
                Kokemuksia
              </Link>
              <Link to="/yhteystiedot">
                <RightArrow />
                Yhteystiedot
              </Link>
              <Link to="/tietosuoja">
                <RightArrow />
                Tietosuoja
              </Link>
            </div>
          </div>
          <div className={linkDivider} />
          <div className={callToAction}>
            <Text>
              UrakkaDiilin avulla löydät luotettavan urakoitsijan remontillesi.
            </Text>
            <Button
              as="a"
              href="https://app.urakkadiili.fi/tarjouspyynnot/uusi"
              rel="nofollow"
            >
              Kilpailuta remonttisi »
            </Button>
            <br />
            <GatsbyImage
              image={data.suomalaistaPalvelua.childImageSharp.gatsbyImageData}
              alt="Avainlippu suomalaista palvelua"
              loading="lazy"
              className={avainlippu}
            />
          </div>
        </Flex>
        <div className={logoIconWrapper}>
          <LogoIcon className={logoIcon} />
          <Logo />
        </div>
      </Container>
    </div>
  );
};

export default Footer;
